import { LocationVarKey, TenantInterface, UserVarKey, UserVarsMap, VarKey } from "@swivl-mono/types";
import { LeaseInterface } from "@swivl-mono/types";
import { useEffect, useMemo, useState } from "react";

import LeasesModel from "../../Models/Leases/Leases.Model";
import LocationsModel from "../../Models/Locations/Locations.Model";
import TenantsModel from "../../Models/Tenants/Tenants.Model";
import { DataCardLease } from "./DataCard.Lease";
import "./DataCard.Leases.scss";

interface LeasesCardProps {
  leases: LeaseInterface[] | undefined;
}

export function DataCardLeases(props: LeasesCardProps) {
  const { leases } = props;

  return (
    <div className="DataCardLeases">
      {leases &&
        leases?.map((lease: LeaseInterface) => {
          return <DataCardLease key={lease.id} lease={lease} />;
        })}
    </div>
  );
}
